import { differenceInCalendarDays } from "./differenceInCalendarDays.js";
import { startOfYear } from "./startOfYear.js";
import { toDate } from "./toDate.js";

/**
 *
 */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getDayOfYear(date, options) {
  const _date = toDate(date, options?.in);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

/*                                */
export default getDayOfYear;
